import type { WrittenPage } from '../../sections'

/**
 * "The Executive's Guide to Sustainable Leadership" e-kitabı — Türkçe.
 *
 * Bölüm sırası, görseller ve maddeler İngilizcesiyle birebir aynı; değişen
 * yalnızca nasıl söylendiği. E-kitabın adı kapağında basılı olduğu için
 * İngilizce kalıyor; "stakeholder", "case study" gibi yerleşik terimler de öyle.
 *
 * İndirilen dosya İngilizce — e-kitabın Türkçesi yok. Bu, sayfayı Türkçe
 * yazmamak için bir sebep değil: sayfayı okuyup indirme kararını veren kişi
 * Türkiye'deki okur, ve karar Türkçe veriliyor.
 *
 * Formla ilgili açık soru İngilizce sayfada duruyor ve orada bir kez duruyor:
 * `check` iki dilde tekrarlanınca aynı karar iki not olarak sayılıyor.
 */
const EBOOK_PDF
  = 'https://njdxtkezxgkrmwwhzcne.supabase.co/storage/v1/object/public/website-documents/ebook/'
  + '396695c4-afaa-464c-9148-89d8044403c2-The%20Executive_s%20Guide%20to%20Sustainable%20Leadership.pdf'

export const ebookExecutivesGuideToSustainableLeadership: WrittenPage = {
  navLabel: 'The Executive’s Guide to Sustainable Leadership',
  title: 'The Executive’s Guide to Sustainable Leadership',
  description:
    'Değişimi en tepeden yönetmek: yöneticilerin sürdürülebilirliği şirketin ana stratejisine '
    + 'yerleştirmesi için içgörüler ve stratejiler. Digitopia Impact Labs e-kitabını indirin.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Değişimi en tepeden yönetin',
      headline: 'The Executive’s Guide to Sustainable Leadership',
      body: [
        'Sürdürülebilirlikte üst yönetimin liderliği, uzun vadeli başarının belirleyicisi. Bu '
          + 'e-kitap, yöneticilerin sürdürülebilirliği şirketin ana iş stratejisine yerleştirmesi '
          + 'için gereken içgörüleri ve stratejileri anlatıyor.',
      ],
      ctas: [{ label: 'İndirin', href: EBOOK_PDF }],
      photo: {
        src: '/photo/sustainable-leadership-ebook-artwork.webp',
        alt:
          'E-kitabın kapak görseli: tam yukarıdan görünen açık mavi bir sarmal merdiven, ortasında '
          + 'canlı yeşil bir bitki adası ve ona uzanan bir kişi.',
      },
      photoFrame: 'square',
    },
    {
      kind: 'cta',
      tone: 'card',
      flip: true,
      heading: 'İçinde ne var?',
      points: [
        'Sürdürülebilirliği yürütmede ve vizyonu koymada üst yönetimin rolü.',
        'Şirket içinde sürdürülebilir bir kültür kurmanın stratejileri.',
        'Stakeholder’ları sürece katmak ve etkili iş birlikleri kurmak üzerine içgörüler.',
        'Levi Strauss & Co. gibi öncü şirketlerden case study’ler.',
        'Sürdürülebilirliği günlük operasyona katmak için pratik adımlar.',
      ],
      ctas: [{ label: 'E-kitabı indirin', href: EBOOK_PDF }],
      photo: {
        src: '/photo/sustainable-leadership-ebook-covers.webp',
        alt:
          'The Executive’s Guide to Sustainable Leadership e-kitabının iki kopyası, biri diğerinin '
          + 'arkasında, açık renkli bir zeminde.',
      },
    },
    {
      kind: 'cta',
      tone: 'card',
      heading: 'Neden indirmelisiniz?',
      points: [
        'Sürdürülebilirliğin üst düzey liderlik için neden bu kadar önemli olduğunu görün.',
        'Şirketinizi sürdürülebilir uygulamalara nasıl yönlendireceğinizi ve harekete '
          + 'geçireceğinizi öğrenin.',
        'Şirketinizin itibarını ve dayanıklılığını artıracak uygulanabilir stratejileri keşfedin.',
      ],
      ctas: [{ label: 'Raporu indirin', href: EBOOK_PDF }],
      photo: {
        src: '/photo/sustainable-leadership-ebook-stack.webp',
        alt:
          'Yukarıdan görünen, üst üste dizilmiş The Executive’s Guide to Sustainable Leadership '
          + 'e-kitabı kopyaları.',
      },
    },
    {
      kind: 'prose',
      align: 'center',
      heading: 'İlham verin. Liderlik edin. Dönüştürün. Ücretsiz e-kitabınızı şimdi indirin',
      sub:
        'Liderliğinizi bir üst basamağa taşıyın, değişimi siz başlatın. “The Executive’s Guide to '
        + 'Sustainable Leadership: Driving Change from the Top” kopyanızı alın ve şirketinizi '
        + 'sürdürülebilir, müreffeh bir geleceğe taşıyın.',
      cta: { label: 'E-kitabı indirin', href: EBOOK_PDF },
    },
  ],
}
